import { Component, Element, Fragment, h, Host, Prop, State, Watch } from "@stencil/core";
import { Font, StzhMostsearchedItem, StzhTopnewsItem } from "../../../index";
import { getTheme } from "../../../utils/utils";
import Curves = Font.Curves;

@Component({
  tag: "stzh-homepage-service-highlights",
  styleUrl: "stzh-homepage-service-highlights.scss",
  scoped: true
})
export class StzhHomepageServiceHighlights {
  @Element() element: HTMLStzhHomepageServiceHighlightsElement;

  /** Top news items */
  @Prop() topnewsItems: StzhTopnewsItem[] | string = [];
  private _topnewsItems: StzhTopnewsItem[] = [];

  /** Most searched items */
  @Prop() mostsearchedItems: StzhMostsearchedItem[] | string = [];
  private _mostsearchedItems: StzhMostsearchedItem[] = [];

  @State() topnewsHeadingCurve: Curves = "h2";

  @Watch("topnewsItems")
  topnewsItemsWatcher(newValue: StzhTopnewsItem[] | string) {
    if (!newValue) {
      this._topnewsItems = [];
    } else if (typeof newValue === "string") {
      try {
        const parsed = JSON.parse(newValue);
        this._topnewsItems = this.ensureSingleHighlight(parsed);
      } catch (e) {
        this._topnewsItems = [];
      }
    } else {
      this._topnewsItems = this.ensureSingleHighlight(newValue);
    }
  }

  @Watch("mostsearchedItems")
  mostsearchedItemsWatcher(newValue: StzhMostsearchedItem[] | string) {
    if (!newValue) {
      this._mostsearchedItems = [];
    } else if (typeof newValue === "string") {
      try {
        this._mostsearchedItems = JSON.parse(newValue);
      } catch (e) {
        this._mostsearchedItems = [];
      }
    } else {
      this._mostsearchedItems = newValue;
    }
  }

  private ensureSingleHighlight(items: StzhTopnewsItem[]): StzhTopnewsItem[] {
    let foundHighlighted = false;

    return items.map(item => {
      if (item.isHighlighted) {
        if (!foundHighlighted) {
          foundHighlighted = true;
          return item;
        } else {
          // Remove highlight from subsequent items
          return { ...item, isHighlighted: false };
        }
      }
      return item;
    });
  }

  private init = () => {
    this.topnewsItemsWatcher(this.topnewsItems);
    this.mostsearchedItemsWatcher(this.mostsearchedItems);
    const theme = getTheme();
    switch (theme) {
      case "stzh-theme-pkzh":
        this.topnewsHeadingCurve = "h4";
        break;
    }
  };

  connectedCallback() {
    this.init();
  }

  private renderTopnewsItemInner(item: StzhTopnewsItem): HTMLElement {
    return (
      <Fragment>
        {!!item.subtitle && <stzh-text class="stzh-topnews-item__subtitle">{item.subtitle}</stzh-text>}
        <stzh-heading class="stzh-topnews-item__label" curve={this.topnewsHeadingCurve}>{item.label}</stzh-heading>
      </Fragment>
    );
  }

  render() {
    const classes = {
      "stzh-homepage-service-highlights": true,
      "stzh-homepage-service-highlights--has-topnews": this._topnewsItems.length > 0
    };

    return (
      <Host>
        <div class={classes}>
          {this._topnewsItems.length > 0 && (
            <div class="stzh-homepage-service-highlights__topnews">
              {this._topnewsItems.map(item =>
                !!item.href ? (
                  <a
                    href={item.href}
                    class={{
                      "stzh-topnews-item": true,
                      "stzh-topnews-item--highlighted": item.isHighlighted,
                      "stzh-topnews-item--has-link": true
                    }}
                  >
                    {this.renderTopnewsItemInner(item)}
                  </a>
                ) : (
                  <div
                    class={{
                      "stzh-topnews-item": true,
                      "stzh-topnews-item--highlighted": item.isHighlighted
                    }}
                  >
                    {this.renderTopnewsItemInner(item)}
                  </div>
                )
              )}
            </div>
          )}
          {this._mostsearchedItems.length > 0 && (
            <div class="stzh-homepage-service-highlights__mostsearched">
              {this._mostsearchedItems.map(item => (
                <div
                  class={{
                    "stzh-mostsearched-item": true
                  }}
                >
                  <stzh-link class="stzh-mostsearched-item__link" href={item.href} icon={"arrow-right"}>
                    {item.label}
                  </stzh-link>
                </div>
              ))}
            </div>
          )}
        </div>
      </Host>
    );
  }
}
